var AddressForm = (function (CheckoutApiCollection, PickupPointField, Decoration, PromiseUtil, CheckoutSettings) {
	return CheckoutApiCollection.extend({
		model: Decoration,

		initialize: function () {
			this._saving = null;
			this._initPickupPointField();
		},

		setDeliveryType: function (type) {
			switch (type) {
				case CheckoutSettings.addressDeliveryTypes.signature:
					this._deliveryType = CheckoutSettings.addressDeliveryTypes.signature;
					break;
				case CheckoutSettings.addressDeliveryTypes.pickup:
					this._deliveryType = CheckoutSettings.addressDeliveryTypes.pickup;
					break;
				default:
					this._deliveryType = null;
					break;
			}
			this.trigger('deliveryTypeChange', this.getDeliveryType());
		},

		getDeliveryType: function () {
			return this._deliveryType;
		},

		save: function () {
			if (this._saving) {
				return this._saving.promise();
            } else if (!this.isValid()) {
			    window.app && app.event && app.event.addressValidation(0);
				return PromiseUtil.rejected();
            }

		    window.app && app.event && app.event.addressValidation(1);

			var address = {};
			var comment = this.getAuthComment();

			this.each(function(m) {
			     address[m.get('Name')] = m.getHidden() === true ? '' : m.get('Value');
			});

			if (comment && this.getDeliveryType() === CheckoutSettings.addressDeliveryTypes.signature) {
				address.AuthComment = comment;
				address.AuthToLeave = true;
			} else {
				address.AuthToLeave = false;
			}

			this.getDeliveryType() === CheckoutSettings.addressDeliveryTypes.pickup &&
			(address = this._addPickupPointToAddress(address));

			this._saving = this._api.setUserDeliveryAddress(address);

            setTimeout(_.bind(function () {
                this._saving.done(_.bind(this._updateCheckout, this))
                    .done(_.bind(this._clearPickupPoints, this))
                    .done(_.bind(this.cancelSignature, this))
					.always(_.bind(function () {
                        this._saving = null;
                    }, this));
            }, this), 0);

            return this._saving.promise();
		},

		isValid: function () {
			var isValid = true;

			if ($.isFunction(this.preValidate) && this.getDeliveryType() === CheckoutSettings.addressDeliveryTypes.pickup) {
				isValid = this.preValidate();
			}

			this.each(function (model) {
				isValid &= model.isValid();
			});

			if (this.getDeliveryType() === CheckoutSettings.addressDeliveryTypes.pickup) {
				isValid &= this.pickupPointField.isValid();
			}
			/*
			if (this.getDeliveryType() === CheckoutSettings.addressDeliveryTypes.signature) {
				isValid &= !!this.isAuthCommentVaild();
			}
			*/

			this.trigger('isValid', isValid);
			return isValid;
		},

		isPickupPointsEnabled: function () {
			return this.pickupPointField.isEnabled();
		},

		isActive: function () {
			return this._isActive;
		},

		setActive: function (isActive) {
			this._isActive = isActive;
			this.trigger('isActive', isActive);
		},

		cancelSignature: function () {
			return this._setAuthComment(null);
		},

		applySignature: function (val) {
			return this._setAuthComment(val);
		},

		getAuthComment: function () {
			return this._authComment;
		},

		/*
        isAuthCommentVaild: function () {
        	var status = !!this.getAuthComment();
        	this.trigger('authCommentValidation', status);
        	return status;
        },
		*/

		_setAuthComment: function (val) {
			this._authComment = val;
			this.trigger('change:AuthComment', this._authComment); //tbd: actually this is should be addition Decoration
			return PromiseUtil.resolved();
		},

		_initPickupPointField: function () {

			this.pickupPointField = new PickupPointField({}, {
				saveOnSelect: false
			});

			this.on('change', function (m) {
				this.getDeliveryType() === CheckoutSettings.addressDeliveryTypes.pickup &&
				m.id === 'Postcode' && this.pickupPointField.propagatePostcodeValue(m.get('Value'));
			}).on('update', function (c) {
				// Populate model first time without firing any events.
				var postcode = c.get('Postcode') ? c.get('Postcode').toJSON() : {};
				this.pickupPointField.populatePostcode(postcode, { silent: true });
			});
		},

		_addPickupPointToAddress: function (address) {
			if (this.pickupPointField.isEnabled()) {
				var selectedPickupPoint = this.pickupPointField.getSelectedPickupPoint();
				if (selectedPickupPoint) {
					address.additionalData = JSON.stringify(selectedPickupPoint);
				}
                if (!address.Postcode) {
                    address.Postcode = selectedPickupPoint.Postcode;
                }
			}
			return address;
		},

		_clearPickupPoints: function () {
			this.pickupPointField.clear();
		},

		pcaUpdateModel: function () {
			this.each(function (model) {
				model.pcaUpdateModel();
			});
		}

	});
})(CheckoutApiCollection, PickupPointField, Decoration, PromiseUtil, CheckoutSettings);
